import React, {useContext} from "react";
import EditNote from '@mui/icons-material/EditNote';
import Button from '@mui/material/Button';
import {AppContext} from '../contexts/context';
import {Replay} from "@mui/icons-material";

export const ScanSlider=(props)=>{
  const [ state, dispatch ] = useContext(AppContext);

  const onReadActionFab = () =>{
    dispatch({type: 'ndef/control/reading'});
  }

  const onWriteActionFab = () =>{
    dispatch({type: 'ndef/control/writing'});
  }

  const buttonStyle = {
    borderRadius: 10,
    width:'100%',
    height:50,
    display: 'flex',
    alignItems: 'center',
    flex: 1
  }

  return(
    props.ndefControl === "idle" ? (
      <div style={{ marginTop:16, display:'flex', width: '100%', gap: 8 }}>
        <Button variant="outlined" onClick={onReadActionFab} sx={buttonStyle}>
          <Replay sx={{ mr: 1 }} />
          Read Tag
        </Button>
        <Button variant="contained" onClick={onWriteActionFab} sx={buttonStyle}>
          <EditNote sx={{ mr: 1 }} />
          Write Tag
        </Button>
      </div>
    ) : (<div style={{height:66}}></div>)
  )
}
